import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

const libraryAxios = createAxiosInstance(env.libraryApiUrl, {
  camelizeKeys: true,
});

const creatorAxios = createAxiosInstance(env.creatorsApiUrl, {
  camelizeKeys: true,
});

export async function getCampaignLevelStats({ brandId, campaignId }) {
  return libraryAxios.get(
    `/brands/${brandId}/campaigns/${campaignId}/creator_insights/campaign_stats`,
  );
}

export async function getCreatorLevelStats({
  brandId,
  creatorIds,
  postsPublishedStartDate,
  postsPublishedEndDate,
  sort,
  restrictToPlatforms,
  postTypes,
  lookupName,
  afterCursor,
  limit,
}) {
  return creatorAxios.put(`/brands/${brandId}/relationships/creator_stats`, {
    creatorIds,
    sort,
    postsPublishedStartDate,
    postsPublishedEndDate,
    restrictToPlatforms,
    postTypes,
    lookupName,
    afterCursor,
    limit,
  });
}
